'use strict';

ebDropdown.$inject = [];

function ebDropdown() {
    return {
        restrict: 'E',
        templateUrl: require('./ebDropdown.html'),
        scope: {
            required: '=',
            for: '@',
            label: '@',
            model: '=',
            options: '=',
            selectProp: '@',
            labelProp: '@'
        }
    };
}

module.exports = ebDropdown;



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/admin/directives/ebDropdownDirective.js
// module id = 36
// module chunks = 0